import { FC } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

export const ImageCellRenderer: FC<ICellRendererParams> = (params) => {
  if (!params.value) {
    return <></>;
  }

  return <img src={params.value} alt={params.column?.getColId()} />;
};
